import $ from 'jquery'
import Backbone from 'backbone'
import template from './recalculate-scores-form.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'

var RecalculateScoresForm = Backbone.View.extend({
	tagName: 'form',
	className: 'recalculate-scores-form',

	initialize: function(options) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.save.bind(this),
			allowCleanSubmission: true
		})
	},

	render: function () {
		this.$el.append(template())
		this.formView.start()
		return this
	},

	save: function () {
		var data = formHelper.readFromDom(this.el)
		var orgId= this.model.id
		$.post({
			url: 'api/organizations/' + orgId + '/recalculate',
			data: JSON.stringify(data)
		}).done(function () {
			this.trigger('done')
		}.bind(this))
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.formView.remove()
	}

})

export default RecalculateScoresForm

RecalculateScoresForm.__filename__ = 'organizations/recalculate-scores-form.js'
